// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessAlert_root__33h5-"};